import React from "react";

export const CartCountContext = React.createContext();
